import { Flex, Icon, ResponsiveValue, Text } from '@chakra-ui/react'
import React from 'react'
import IconMangoLogo from '~/assets/svgs/icon-mango-logo.svg?react'
import IconPhoneHold from '~/assets/svgs/icon-phone-hold.svg?react'
import IconPhoneMute from '~/assets/svgs/icon-phone-mute.svg?react'
import IconCaution from '~/assets/svgs/icon-warning-triangle.svg?react'
import { Size } from '~/types/ThemeTypes'

import {
  CallSoundIndicatorVariants,
  useCallSoundIndicatorStyles,
} from './componentStyles/CallSoundIndicator.style'

const VariantMap = {
  [CallSoundIndicatorVariants.Active]: {
    icon: IconMangoLogo,
    text: '',
  },
  [CallSoundIndicatorVariants.Hold]: {
    icon: IconPhoneHold,
    text: 'On Hold',
  },
  [CallSoundIndicatorVariants.Mute]: {
    icon: IconPhoneMute,
    text: 'Muted',
  },
  [CallSoundIndicatorVariants.Reconnecting]: {
    icon: IconCaution,
    text: 'Reconnecting',
  },
}

interface CallSoundIndicatorProps {
  variant: CallSoundIndicatorVariants
  size: ResponsiveValue<Size.sm | Size.md | Size.lg>
}
export const CallSoundIndicator = ({
  variant,
  size,
}: CallSoundIndicatorProps) => {
  const styles = useCallSoundIndicatorStyles({ variant, size })
  const { icon, text } = VariantMap[variant]
  return (
    <Flex sx={styles.container}>
      <Flex sx={styles.pulse}></Flex>
      <Flex direction="column" sx={styles.core}>
        <Icon as={icon} sx={styles.icon} />
        <Text sx={styles.text}>{text}</Text>
      </Flex>
    </Flex>
  )
}
